import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { withTranslation } from "react-i18next";

import axios from "./Axios";
import "../pages/account/account.css";

const MAX_QTY = 999;
const clamp = (v) => Math.min(MAX_QTY, Math.max(1, v));
const usd = (v) => v.toFixed(2) + " USD";

// Add Credits dialog (Billing): credits at a unit price, plus the storage subscription when the user has none yet
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      qty: 5,
      unit: 5,
      errorMessage: "",
    };
  }

  setQty = (v) => this.setState({ qty: clamp(v) });

  // allow an empty field while typing; settle on a valid number on blur
  qtyChange = (e) => {
    const v = parseInt(e.target.value, 10);
    this.setState({ qty: isNaN(v) ? "" : clamp(v) });
  };

  qtyBlur = () => {
    if (this.state.qty === "") this.setState({ qty: 1 });
  };

  close = () => {
    this.setState({ errorMessage: "" });
    this.props.onClose();
  };

  buyPress = async () => {
    this.setState({ loading: true, errorMessage: "" });
    try {
      if (!this.props.subscribed) {
        await axios.post("/user/stripe/subscription", {});
      }
      const response = await axios.post("/user/stripe/add_credit", { qty: this.state.qty });
      this.setState({ loading: false });
      if (response.data["succeeded"] === false) {
        // stay open with the card error; the parent reloads, since a subscription may have started
        this.setState({ errorMessage: response.data["error"]["message"] });
        if (this.props.onRefresh) this.props.onRefresh();
        return;
      }
      this.props.onSuccess();
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { t, subscribed } = this.props;
    const { qty, unit, loading } = this.state;
    const total = unit * (qty || 0);

    return (
      <Dialog open={this.props.open} onClose={this.close} aria-labelledby="ac-credits-h" PaperProps={{ className: "ac-dialog", elevation: 0 }}>
        <div className="ac-head">
          <h2 id="ac-credits-h" className="ac-title">
            {t("Add Credits")}
          </h2>
          <span className="ac-spacer" />
          <button type="button" className="ac-sq" title={t("Close")} aria-label={t("Close")} onClick={this.close}>
            <CloseIcon />
          </button>
        </div>

        <div className="ac-body" style={{ paddingTop: "4px", gap: "0" }}>
          <div className="ac-line">
            <div style={{ minWidth: 0 }}>
              <div className="ac-name">{t("VideoViews Credits")}</div>
              <p className="ac-help">
                {t("1 credit provides A.I Analysis")} {t("for 1 hour of video content")}
              </p>
            </div>
            <div className="ac-qty">
              <label htmlFor="ac-credits-qty">{t("Qty")}</label>
              <button type="button" className="ac-sq" aria-label={t("Fewer credits")} onClick={() => this.setQty((qty || 1) - 1)} disabled={qty <= 1}>
                <RemoveIcon />
              </button>
              <input
                id="ac-credits-qty"
                type="number"
                min="1"
                max={MAX_QTY}
                inputMode="numeric"
                value={qty}
                onChange={this.qtyChange}
                onBlur={this.qtyBlur}
              />
              <button type="button" className="ac-sq" aria-label={t("More credits")} onClick={() => this.setQty((qty || 0) + 1)} disabled={qty >= MAX_QTY}>
                <AddIcon />
              </button>
            </div>
            <div className="ac-amount">
              <b>{usd(total)}</b>
              <span className="ac-meta">
                {usd(unit)} {t("per credit")}
              </span>
            </div>
          </div>

          {!subscribed && (
            <div className="ac-line">
              <div style={{ minWidth: 0 }}>
                <div className="ac-name">{t("VideoViews Data Storage and Access")}</div>
                <p className="ac-help">{t("Provides data storage and searchable access for video AI analysis results")}</p>
              </div>
              <span />
              <div className="ac-amount">
                <b>10 USD/{t("month")}</b>
                <span className="ac-meta">
                  +0.50 USD/mo {t("per hours over")} 20 {t("hours")}
                </span>
              </div>
            </div>
          )}

          <div className="ac-line ac-total">
            <div className="ac-name">{t("Total")}</div>
            <span />
            <div className="ac-amount">
              <b>{usd(total)}</b>
            </div>
          </div>

          {this.state.errorMessage !== "" && (
            <Alert severity="error" onClose={() => this.setState({ errorMessage: "" })} style={{ marginTop: "12px" }}>
              {this.state.errorMessage}
            </Alert>
          )}
        </div>

        <div className="ac-foot">
          <Button className="Button ac-btn" onClick={this.close}>
            {t("Cancel")}
          </Button>
          <Button className="Button ButtonPrimary ac-btn" disabled={loading || !qty} onClick={this.buyPress}>
            {subscribed ? t("Buy") : t("Buy and Subscribe")}
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default withTranslation()(Index);
